exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-vacancy-english-teacher-js": () => import("./../../../src/pages/vacancy-english-teacher.js" /* webpackChunkName: "component---src-pages-vacancy-english-teacher-js" */),
  "component---src-templates-document-template-js": () => import("./../../../src/templates/document-template.js" /* webpackChunkName: "component---src-templates-document-template-js" */)
}

